// import store from "../store";
import store from "@/store";

export default function package_contains(package_item) {
  const present_package_items = store.getters.packageItems;

  return present_package_items.some((item) => item === package_item);
}
